if (!customElements.get('deployer-cart-drawer')) {
  customElements.define(
    'deployer-cart-drawer',
    class DeployerCartDrawer extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

        this.querySelector('#DeployerCartDrawer-Checkout').addEventListener('click', (event) => {
          event.target.classList.add('deployer-button--is-loading');
        });

        // Connecte le panier à l'icône du panier
        this.setHeaderCartIconAccessibility();

        // Connecte le panier aux formulaires des pages produit
        this.setProductFormCompatibility(this);

        this.connectCartItemsListeners();
      }

      initializeToggleProduct() {
        this.toggleProductInput = this.querySelector('.deployer-cart-drawer__toggle-product-input');

        if (this.toggleProductInput) {
          this.toggleProductInput.addEventListener('click', (event) => {
            this.handleToggleProduct(event);
          });
          this.updateToggleProductCheckbox();
        }
      }

      connectCartItemsListeners() {
        // Supprimer les anciens écouteurs d'événements
        const overlay = this.querySelector('.deployer-cart-drawer__overlay');
        const newOverlay = overlay.cloneNode(true);
        overlay.parentNode.replaceChild(newOverlay, overlay);
        newOverlay.addEventListener('click', this.close.bind(this));

        // Supprimer l'ancien écouteur d'événement pour deployer-cart-drawer:refresh
        document.removeEventListener('deployer-cart-drawer:refresh', this.refreshCartHandler);
        this.refreshCartHandler = async () => {
          await this.refreshCart();
        };
        document.addEventListener('deployer-cart-drawer:refresh', this.refreshCartHandler);

        // Supprimer l'ancien écouteur d'événement pour deployer-cart-drawer:open
        document.removeEventListener('deployer-cart-drawer:open', this.openHandler);
        this.openHandler = async () => {
          await this.refreshCart();
          this.open();
        };
        document.addEventListener('deployer-cart-drawer:open', this.openHandler);

        // Gérer les éléments du panier
        this.querySelectorAll('.deployer-cart-drawer__item').forEach((cart_item) => {
          // Supprimer les anciens écouteurs d'événements
          const newCartItem = cart_item.cloneNode(true);
          cart_item.parentNode.replaceChild(newCartItem, cart_item);

          // Clic sur le bouton supprimer
          const cart_item_remove_button = newCartItem.querySelector('.deployer-cart-drawer__item-remove');
          if (cart_item_remove_button) {
            cart_item_remove_button.addEventListener('click', (event) => {
              event.preventDefault();
              this.updateLineItemQuantity(cart_item_remove_button.dataset.index, 0);
            });
          }

          const cart_item_input = newCartItem.querySelector('.deployer-quantity input');

          if (cart_item_input) {
            // Mise à jour de l'input de quantité
            cart_item_input.addEventListener('change', () => {
              this.updateLineItemQuantity(cart_item_input.dataset.index, cart_item_input.value);
            });

            // Clic sur les boutons de quantité
            newCartItem.querySelectorAll('.deployer-quantity button:not(:disabled)').forEach((button) => {
              button.addEventListener('click', (event) => {
                this.onQuantityButtonClick(event, cart_item_input);
              });
            });
          }
        });

        // Initialisation de la checkbox du produit toggle
        this.initializeToggleProduct();
      }

      setHeaderCartIconAccessibility() {
        if (window.deployerAdapter.cartIcon) {
          window.deployerAdapter.cartIcon.addEventListener('click', (event) => {
            event.preventDefault();
            this.open();
          });
        } else {
          console.error('Icône du panier non trouvée');
        }
      }

      // Intercepte les ajouts au panier pour les envoyer à la méthode de rendu du panier
      setProductFormCompatibility(cartDrawer) {
        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          form.querySelectorAll('[name="add"]').forEach((button) => {
            button.addEventListener('click', function (event) {
              event.preventDefault(), event.stopPropagation();

              if (button.getAttribute('aria-disabled') === 'true') return;

              button.setAttribute('aria-disabled', true);
              button.classList.add('deployer-button--is-loading');

              const config = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: `application/javascript`,
                },
              };
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];

              const formData = new FormData(button.closest('form'));

              formData.append(
                'sections',
                document
                  .querySelector('deployer-cart-drawer')
                  .getSectionsToRender()
                  .map((section) => section.section),
              );
              formData.append('sections_url', window.location.pathname);

              config.body = formData;

              fetch('/cart/add', config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    document.dispatchEvent(
                      new CustomEvent('toast:open', {
                        detail: {
                          type: 'error',
                          message: response.description,
                        },
                      }),
                    );
                    return;
                  }
                  document.querySelector('deployer-cart-drawer').renderCartContents(response);
                })
                .catch((e) => {
                  console.error(e);
                  document.dispatchEvent(
                    new CustomEvent('toast:open', {
                      detail: {
                        type: 'error',
                        message: "Erreur d'ajout au panier",
                      },
                    }),
                  );
                })
                .finally(() => {
                  button.classList.remove('deployer-button--is-loading');
                  button.removeAttribute('aria-disabled');
                });
            });
          });
        });
      }

      open() {
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
          this.classList.add('animate', 'active');

          const popupElement = document.querySelector('#wisepops-root');
          if (popupElement) {
            popupElement.style.display = 'none';
          }
        });
        window.deployerAdapter.containerToAvoidScroll.classList.add(window.deployerAdapter.classToAvoidScroll);
      }

      close() {
        this.classList.remove('active');
        window.deployerAdapter.containerToAvoidScroll.classList.remove(window.deployerAdapter.classToAvoidScroll);
        if (window.deployerAdapter.containerToAvoidScroll.style.overflow === 'hidden') {
          window.deployerAdapter.containerToAvoidScroll.style.overflow = 'auto';
        }
        const popupElement = document.querySelector('#wisepops-root');
        if (popupElement) {
          popupElement.style.display = 'block';
        }
      }

      getSectionsToRender() {
        const cartContainerSectionId = window.deployerAdapter.cartIcon
          .closest('.shopify-section')
          .id.replace('shopify-section-', '');
        return [
          {
            id: 'deployer-cart-drawer',
            section: 'deployer-cart-drawer',
            selector: '.deployer-cart-drawer__inner',
          },
          {
            id: cartContainerSectionId,
            section: cartContainerSectionId,
            selector: window.deployerAdapter.cartIconSelector,
          },
        ];
      }

      renderCartContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          const temporaryDom = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
          if (temporaryDom.querySelector(section.selector)) {
            sectionElement.innerHTML = temporaryDom.querySelector(section.selector).innerHTML;
          } else {
            sectionElement.innerHTML = temporaryDom.querySelector('.shopify-section').innerHTML;
          }
        });

        // Mettre à jour l'état du panier
        if (parsedState.item_count == 0) {
          this.classList.add('deployer-cart-drawer--empty');
        } else {
          this.classList.remove('deployer-cart-drawer--empty');
        }

        // Réinitialiser les écouteurs d'événements
        this.connectCartItemsListeners();

        // Ouvrir le drawer si nécessaire
        if (!this.classList.contains('active')) {
          this.open();
        }

        // Déclencher l'événement de rafraîchissement pour le gift-dispatcher
        document.dispatchEvent(new Event('deployer-cart-drawer:refresh'));
      }

      async refreshCart() {
        return new Promise((resolve) => {
          fetch(window.Shopify.routes.root + '?sections=deployer-cart-drawer')
            .then((res) => res.json())
            .then((data) => {
              this.innerHTML = new DOMParser()
                .parseFromString(data['deployer-cart-drawer'], 'text/html')
                .querySelector('deployer-cart-drawer').innerHTML;

              // Vérifier si le panier est vide
              fetch('/cart.js')
                .then((res) => res.json())
                .then((cart) => {
                  if (cart.item_count === 0) {
                    this.classList.add('deployer-cart-drawer--empty');
                  } else {
                    this.classList.remove('deployer-cart-drawer--empty');
                  }

                  setTimeout(() => {
                    this.connectCartItemsListeners();
                    resolve();
                  });
                });
            });
        });
      }

      onQuantityButtonClick(event, cart_item_input) {
        event.preventDefault();
        const previousValue = cart_item_input.value;

        event.target.name === 'plus' ? cart_item_input.stepUp() : cart_item_input.stepDown();
        if (previousValue !== cart_item_input.value) {
          let timeout;
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            this.updateLineItemQuantity(cart_item_input.dataset.index, cart_item_input.value);
          }, 300);
        }
      }

      updateLineItemQuantity(line, quantity) {
        this.enableLoading(line);

        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch('/cart/change', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: `application/json`,
          },
          ...{ body },
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            const quantityElement = document.getElementById(`DeployerCartDrawer-Quantity-${line}`);

            if (parsedState.errors) {
              quantityElement.value = quantityElement.getAttribute('value');
              this.setLineItemError(line, parsedState.errors);
              return;
            }

            this.renderCartContents(parsedState);
          })
          .catch((e) => {
            console.error(e);
            this.setCartError("Une erreur est survenue lors de l'actualisation de votre panier. Veuillez réessayer.");
            this.disableLoading(line);
          })
          .finally(() => {
            this.disableLoading(line);
          });
      }

      setLineItemError(line, message) {
        if (document.querySelector('deployer-toast-notification')) {
          document.dispatchEvent(
            new CustomEvent('toast:open', {
              detail: { type: 'error', message: message },
            }),
          );
          return;
        }
        const lineItemError = document.getElementById(`DeployerCartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.querySelector('.deployer-cart-drawer__item-error-text').innerHTML = message;
      }

      setCartError(message) {
        if (document.querySelector('deployer-toast-notification')) {
          document.dispatchEvent(
            new CustomEvent('toast:open', {
              detail: { type: 'error', message: message },
            }),
          );
          return;
        }
        document.getElementById('DeployerCartDrawer-CartErrors').textContent = message;
      }

      enableLoading(line) {
        const mainCartItems = document.querySelector('.deployer-cart-drawer__items');
        mainCartItems.classList.add('deployer-cart-drawer__items--disabled');
        const cartDrawerItemElements = this.querySelectorAll(`#DeployerCartDrawer-Item-${line} .loading__spinner`);
        cartDrawerItemElements.forEach((overlay) => overlay.classList.remove('hidden'));
        document.querySelector('.deployer-cart-drawer__totals-value').classList.add('deployer-loading');
        if (document.querySelector('.deployer-cart-drawer__reductions-value')) {
          document.querySelector('.deployer-cart-drawer__reductions-value').classList.add('deployer-loading');
        }
        if (document.querySelector(`#DeployerCartDrawer-Item-${line}`)) {
          document
            .querySelector(`#DeployerCartDrawer-Item-${line} .deployer-cart-drawer__item-prices`)
            .classList.add('deployer-loading');
        }
      }

      disableLoading(line) {
        const mainCartItems = document.querySelector('.deployer-cart-drawer__items');
        mainCartItems.classList.remove('deployer-cart-drawer__items--disabled');
        const cartDrawerItemElements = this.querySelectorAll(`#DeployerCartDrawer-Item-${line} .loading__spinner`);
        cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
        document.querySelector('.deployer-cart-drawer__totals-value').classList.remove('deployer-loading');
        if (document.querySelector('.deployer-cart-drawer__reductions-value')) {
          document.querySelector('.deployer-cart-drawer__reductions-value').classList.remove('deployer-loading');
        }
        if (document.querySelector(`#DeployerCartDrawer-Item-${line}`)) {
          document
            .querySelector(`#DeployerCartDrawer-Item-${line} .deployer-cart-drawer__item-prices`)
            .classList.remove('deployer-loading');
        }
      }

      async handleToggleProduct(event) {
        const input = event.target.closest('.deployer-checkbox').querySelector('input');
        const variantId = input.dataset.variantId;
        const isChecked = input.checked;

        try {
          // Vérifier d'abord si le produit est déjà dans le panier
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          const isInCart = cart.items.some((item) => item.variant_id.toString() === variantId);

          if (isInCart) {
            await this.removeToggleProduct(variantId);
          } else {
            await this.addToggleProduct(variantId);
          }

          // Rafraîchir le panier
          const updatedCartResponse = await fetch('/cart.js');
          const updatedCart = await updatedCartResponse.json();

          document.dispatchEvent(new Event('cart-product:change'));

          // Mettre à jour l'affichage du panier
          const sectionsResponse = await fetch(window.Shopify.routes.root + '?sections=deployer-cart-drawer');
          const sectionsData = await sectionsResponse.json();

          // Vérifier que nous avons les données nécessaires
          if (!sectionsData || !sectionsData['deployer-cart-drawer']) {
            throw new Error('Données de section manquantes');
          }

          // Mettre à jour le contenu du panier
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sectionsData['deployer-cart-drawer'];
          const newCartDrawer = tempDiv.querySelector('deployer-cart-drawer');

          if (newCartDrawer) {
            this.innerHTML = newCartDrawer.innerHTML;

            // Réinitialiser tous les event listeners
            this.connectCartItemsListeners();

            if (updatedCart.item_count === 0) {
              this.classList.add('deployer-cart-drawer--empty');
            } else {
              this.classList.remove('deployer-cart-drawer--empty');
            }
          }

          // Mettre à jour l'état de la checkbox immédiatement
          const updatedIsInCart = updatedCart.items.some((item) => item.variant_id.toString() === variantId);
          const checkbox = this.querySelector(`input[data-variant-id="${variantId}"]`);
          if (checkbox) {
            checkbox.checked = updatedIsInCart;
          }
        } catch (error) {
          console.error('Erreur:', error);
          // Remettre la case à cocher dans son état précédent
          input.checked = !isChecked;

          // Afficher un message d'erreur
          document.dispatchEvent(
            new CustomEvent('toast:open', {
              detail: {
                type: 'error',
                message: 'Une erreur est survenue lors de la mise à jour du panier',
              },
            }),
          );
        }
      }

      async addToggleProduct(variantId) {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  _is_toggle_product: true,
                },
              },
            ],
          }),
        });

        if (!response.ok) {
          throw new Error("Erreur lors de l'ajout du produit");
        }
        else {
          document.dispatchEvent(new CustomEvent('cart-product:add'));
        }
      }

      async removeToggleProduct(variantId) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 0,
          }),
        });

        if (!response.ok) {
          throw new Error('Erreur lors de la suppression du produit');
        }
        else {
          document.dispatchEvent(new CustomEvent('cart-product:change'));
        }
      }

      async updateToggleProductCheckbox() {
        if (!this.toggleProductInput) return;

        const input = this.toggleProductInput.querySelector('input');

        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();

          const toggleProductVariantId = input.dataset.variantId;
          const isInCart = cart.items.some((item) => item.variant_id.toString() === toggleProductVariantId);

          input.checked = isInCart;
        } catch (error) {
          console.error('Erreur lors de la vérification du panier:', error);
        }
      }
    },
  );
}

if (!customElements.get('deployer-cart-cross-sells')) {
  customElements.define(
    'deployer-cart-cross-sells',
    class DeployerCartCrossSells extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.isCollapsed = false;
      }

      connectedCallback() {
        if (!this.initialized) {
          this.initializeToggle();
          this.initializeSlider();
          this.initialized = true;

          this.querySelectorAll('.deployer-cart-drawer__cross-sell-add').forEach((button) => {
            button.addEventListener('click', this.handleCrossSellAdd.bind(this));
          });
        }
      }

      initializeToggle() {
        this.header = this.querySelector('.deployer-cart-drawer__cross-sells-header');
        this.toggleButton = this.querySelector('.deployer-cart-drawer__cross-sells-toggle');
        this.content = this.querySelector('.deployer-cart-drawer__cross-sells-content');

        if (this.header && this.toggleButton && this.content) {
          this.header.addEventListener('click', this.handleToggle.bind(this));
          this.toggleButton.addEventListener('click', (e) => {
            e.stopPropagation();
            this.handleToggle();
          });
        }
      }

      handleToggle() {
        this.isCollapsed = !this.isCollapsed;
        
        if (this.isCollapsed) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      collapse() {
        const content = this.querySelector('.deployer-cart-drawer__cross-sells-content');
        const contentHeight = content.scrollHeight;
        
        // Définir la hauteur actuelle pour permettre la transition
        content.style.height = contentHeight + 'px';
        
        // Forcer un reflow
        content.offsetHeight;
        
        // Ajouter la classe collapsed et définir la hauteur à 0
        this.classList.add('collapsed');
        content.style.height = '0px';
        
        this.toggleButton.setAttribute('aria-expanded', 'false');
      }

      expand() {
        const content = this.querySelector('.deployer-cart-drawer__cross-sells-content');
        
        // Retirer la classe collapsed
        this.classList.remove('collapsed');
        
        // Définir la hauteur à auto pour calculer la hauteur naturelle
        content.style.height = 'auto';
        const contentHeight = content.scrollHeight;
        
        // Définir la hauteur à 0 pour permettre la transition
        content.style.height = '0px';
        
        // Forcer un reflow
        content.offsetHeight;
        
        // Animer vers la hauteur naturelle
        content.style.height = contentHeight + 'px';
        
        this.toggleButton.setAttribute('aria-expanded', 'true');
        
        // Nettoyer après la transition
        const transitionEndHandler = () => {
          content.style.height = 'auto';
          content.removeEventListener('transitionend', transitionEndHandler);
        };
        
        content.addEventListener('transitionend', transitionEndHandler);
      }

      initializeSlider() {
        this.track = this.querySelector('.deployer-cart-drawer__cross-sells-track');
        this.prev = this.querySelector('.deployer-cart-drawer__cross-sells-prev');
        this.next = this.querySelector('.deployer-cart-drawer__cross-sells-next');
        this.items = this.querySelectorAll('.deployer-cart-drawer__cross-sell-item');

        if (!this.track || !this.items.length) return;

        this.currentSlide = 0;

        // Utiliser requestAnimationFrame pour s'assurer que les dimensions sont calculées après le rendu
        requestAnimationFrame(() => {
          const itemWidth = this.querySelector('.deployer-cart-drawer__cross-sell-item').offsetWidth;
          if (itemWidth > 0) {
            this.slidesPerView = Math.floor(this.offsetWidth / itemWidth);
            this.updateSliderButtons();
          } else {
            // Si les dimensions sont toujours à 0, réessayer après un court délai
            setTimeout(() => {
              const retryItemWidth = this.querySelector('.deployer-cart-drawer__cross-sell-item').offsetWidth;
              this.slidesPerView = Math.floor(this.offsetWidth / retryItemWidth);
              this.updateSliderButtons();
            }, 100);
          }
        });

        if (this.prev) {
          this.prev.addEventListener('click', () => this.slide('prev'));
        }

        if (this.next) {
          this.next.addEventListener('click', () => this.slide('next'));
        }
      }

      slide(direction) {
        if (!this.track || !this.items.length) return;

        if (direction === 'prev' && this.currentSlide > 0) {
          this.currentSlide--;
        } else if (direction === 'next' && this.currentSlide < this.items.length - this.slidesPerView) {
          this.currentSlide++;
        }

        this.track.style.transform = `translateX(-${
          this.currentSlide * (this.querySelector('.deployer-cart-drawer__cross-sell-item').offsetWidth + 10)
        }px)`;

        this.updateSliderButtons();
      }

      updateSliderButtons() {
        if (!this.prev || !this.next) return;

        this.prev.disabled = this.currentSlide === 0;
        this.next.disabled = this.currentSlide >= this.items.length - this.slidesPerView;
      }

      async handleCrossSellAdd(event) {
        const button = event.currentTarget;
        const variantId = button.dataset.variantId;
        const spinner = button.querySelector('.deployer-button__loading-spinner');
        const buttonText = button.querySelector('span:not(.deployer-button__loading-spinner)');

        button.disabled = true;
        spinner.classList.remove('hidden');
        buttonText.classList.add('hidden');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                },
              ],
            }),
          });

          if (!response.ok) {
            throw new Error("Erreur lors de l'ajout au panier");
          }

          this.closest('deployer-cart-drawer').refreshCart();
        } catch (error) {
          console.error('Erreur:', error);
          // Afficher un message d'erreur à l'utilisateur
          const errorMessage = document.createElement('div');
          errorMessage.classList.add('deployer-cart-drawer__error');
          errorMessage.textContent = "Une erreur est survenue lors de l'ajout au panier";
          button.parentNode.insertBefore(errorMessage, button);
          setTimeout(() => errorMessage.remove(), 3000);
        } finally {
          button.disabled = false;
          spinner.classList.add('hidden');
          buttonText.classList.remove('hidden');
          document.dispatchEvent(new CustomEvent('cart-product:add'));
        }
      }
    },
  );
}

class DeployerCartNote extends HTMLElement {
  constructor() {
    super();

    let inputTimeout;
    this.addEventListener('input', (event) => {
      clearTimeout(inputTimeout);
      inputTimeout = setTimeout(() => {
        const body = JSON.stringify({ note: event.target.value });
        fetch('/cart/update', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: body,
        });
      }, 300);
    });
  }
}

if (!customElements.get('deployer-cart-note')) customElements.define('deployer-cart-note', DeployerCartNote);
